import { render, staticRenderFns } from "./EditorGroup.vue?vue&type=template&id=24b51ed8"
import script from "./EditorGroup.vue?vue&type=script&lang=js"
export * from "./EditorGroup.vue?vue&type=script&lang=js"
import style0 from "./EditorGroup.vue?vue&type=style&index=0&id=24b51ed8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports